/**
 * Temporary Debug Component - Fix Partner Access Button
 * DELETE THIS FILE AFTER FIXING THE ISSUE
 */
import React, { useState } from 'react';
import api from '../utils/api';

const FixPartnerAccessButton = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const checkStatus = async () => {
    setLoading(true);
    try {
      const response = await api.get('/api/debug/partner-relationship');
      setStatus(response.data);
      console.log('Partner Relationship Status:', response.data);
    } catch (error) {
      console.error('Error checking status:', error);
      setStatus({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const fixRelationship = async () => {
    setLoading(true);
    try {
      const response = await api.post('/api/debug/fix-partner-relationship');
      setStatus(response.data);
      console.log('Fix Result:', response.data);
      alert('Partner relationship fixed! Please refresh the page.');
    } catch (error) {
      console.error('Error fixing relationship:', error);
      setStatus({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-yellow-50 border-2 border-yellow-400 rounded-lg p-4 mb-4">
      <h3 className="text-lg font-semibold text-yellow-800 mb-2">
        🔧 Debug: Partner Access Fix
      </h3>
      <p className="text-sm text-yellow-700 mb-3">
        If you can't see your partner's cash flow, click these buttons to diagnose and fix the issue.
      </p>
      
      <div className="flex gap-2 mb-3">
        <button
          onClick={checkStatus}
          disabled={loading}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
        >
          {loading ? 'Checking...' : 'Check Status'}
        </button>
        
        <button
          onClick={fixRelationship}
          disabled={loading}
          className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 disabled:opacity-50"
        >
          {loading ? 'Fixing...' : 'Fix Partner Access'}
        </button>
      </div>

      {status && (
        <div className="bg-white rounded p-3 text-sm">
          <pre className="whitespace-pre-wrap overflow-auto max-h-96">
            {JSON.stringify(status, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default FixPartnerAccessButton;

